export const ACTION_TYPES = {
  UPDATE_PLAY_SOURCE: 'player/UPDATE_PLAY_SOURCE',
  UPDATE_ACTION_ORIGIN: 'player/UPDATE_ACTION_ORIGIN',
};

// Update play source
export const updatePlaySource = (playSource) => ({
  type: ACTION_TYPES.UPDATE_PLAY_SOURCE,
  payload: playSource,
});

// Update action origin
export const updateActionOrigin = (actionOrigin) => ({
  type: ACTION_TYPES.UPDATE_ACTION_ORIGIN,
  payload: actionOrigin,
});
